import { useEffect, useCallback } from 'react'

import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import { styled } from '@mui/material/styles'

import { capitalizeWords } from 'services/utils'

import Loading from 'Components/Loading'
import Title from 'Components/Title'
import config from '../../../static/Dia' 
import Back from 'Components/Back'
import { useHistory } from 'Components/useHistory'
import Modal from 'Components/Modal'
import useDias from 'hooks/useDias'

const style = { 
    button: {
        minHeight: '120px',
        height: '100%',
        cursor: 'pointer',
        color: '#000',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        padding: 0,
        margin: 0,
    },
    span: {
        fontSize: '13px', 
        padding: '5px 0'
    }
}

const ButtonPage = styled(Button)({
    textTransform: 'Capitalize', 
    color: '#000', 
    margin: '0 !important'
})

const Dia = ({totalByPerPage = 6}) => {
    const { historyPaths } = useHistory()
    const { 
        loading,
        items,
        data,
        count,
        page,
        onPageChange,
        selectItem,
        getDias,
        patient,
        isOpen,
        modal
    } = useDias()
    
    historyPaths.add('/dia')

    useEffect(() => {
        getDias()
    }, [getDias])

    const getDayFormated = useCallback(item => {
        const day = item.dataAgenda?.substring(0,2)
        return (
            <Button 
                component={Paper} 
                id={day}
                sx={style.button}
                elevation={4}
                onClick={() => selectItem(item.dataAgenda)}
            > 
                <Typography sx={style.span} variant='span' component='span'>
                    {item.diaSemana}
                </Typography>
                <Typography variant='h4' component='h2'>
                    {day}
                </Typography>
                <Typography sx={style.span} variant='span' component='span'>
                    {item.dataAgenda}
                </Typography>
            </Button>  
        )
    }, [selectItem])

    const MoreOtherDays = useCallback(() => {
        return (
            <ButtonPage component={Paper} elevation={4}>
                <Typography variant='p' component='p'>
                    + Outras datas
                </Typography>
            </ButtonPage>
        )
    }, [])

    const LessOtherDays = useCallback(() => {
        return (
            <ButtonPage component={Paper} elevation={4}>
                <Typography variant='p' component='p'>
                    - Outras datas
                </Typography>
            </ButtonPage>
        )
    }, [])

    const DayOrOther = useCallback(({ item }) => {
        return getDayFormated(item)
    }, [getDayFormated])

    const descricao = capitalizeWords(patient?.descricaoEspecialidade)
    const descricaoEspecialidade = descricao ? ` de ${descricao}?` : ''
    const title = config.title + descricaoEspecialidade

    return (
        <>
            <Modal
                {...modal}
                disableCancel={true}
                open={isOpen} 
                hideImportant
            />
            {!isOpen && (
                <>
                    <Title title={title} />
                    <Box sx={{
                        py: 2,
                        bgcolor: 'background.default',
                        display: 'grid',
                        gridTemplateColumns: { md: `repeat(${totalByPerPage / 2}, 1fr)`, xs: '1fr 1fr' },
                        gap: 2,
                        wrap: 'no-wrap'
                    }}>
                        {data.map((item, i) => (
                            <DayOrOther key={i} item={item} />
                        ))}
                    </Box>
                </>
            )}

            <Stack sx={{
                py: 2,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Pagination
                    size="large"
                    onChange={(_, p) => onPageChange(p)}
                    page={page}
                    count={count}
                    sx={{
                        'ul': {
                            justifyContent: 'space-between'
                        },
                        'css-vfb1yb-MuiStack-root': { paddingTop: 0 },
                        '& button.MuiButtonBase-root': { padding: 0 },
                    }}
                    renderItem={item => {
                        
                        if (item.type === 'page' || items?.length < totalByPerPage) {
                            return null
                        }

                        return (
                            <PaginationItem
                                components={{ 
                                    previous: LessOtherDays, 
                                    next: MoreOtherDays 
                                }}
                                {...item}
                            />
                        )
                    }}
                />
            </Stack>
            {loading && <Loading />}
            {!isOpen && <Back loading={loading} />}
        </>
    )
}

export default Dia
